export default function AboutHero() {
  return (
    <section className="relative pt-24 pb-0 min-h-[60vh] flex items-end overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.readdy.ai/image/18ca25ea8a69d5eb1e849ccadbb7687f/20e949ae20102ffd81e17deb09c55c60.jpeg"
          alt="Sydney residential neighbourhood"
          className="w-full h-full object-cover object-[center_30%]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/60 to-navy-950/90" />
      </div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pb-16">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-0.5 bg-gold-400" />
          <span className="text-gold-400 text-sm font-medium tracking-widest uppercase">Our Story</span>
        </div>
        <h1 className="font-heading text-5xl lg:text-6xl font-bold text-white leading-tight max-w-2xl">
          About Galaxy Housing
        </h1>
      </div>
    </section>
  );
}
